// extracted by mini-css-extract-plugin
module.exports = {"layout":"featured-content_layout__X7QxS","heading":"featured-content_heading__YwvV0","content":"featured-content_content__SoYqp"};